<app-code-view [isTitle]="true">
  <h4 Ctitle>
    @if (this.formGroup?.get('sheets')) {
      <span class="f-s-14 f-w-400 d-block">This table contains only the first five rows of the uploaded file. Please give decisions for each sheet that your file contain.</span>
    } @else {
      <span class="f-s-14 f-w-400 d-block">This table contains only the first five rows of the uploaded file. After selecting a division type please mark your division fields.</span>
    }
  </h4>
  <div output>
    <mat-tab-group (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="false" animationDuration="500ms">
      <mat-tab *ngFor="let sheet of sheetsOfExcel; let i = index">
        <ng-template mat-tab-label>
          {{sheet.name}}
        </ng-template>
        <div class="table-responsive ">
          <table *ngIf="sheet.columns.length > 0" mat-table [dataSource]="getFilteredDataSource(sheet, i)" class="w-100 p-t-10">
            <ng-container *ngFor="let column of sheet.columns; let k = index" [matColumnDef]="column">
                        <th mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 p-l-0 align-items-lg-center">
              @if (this.formGroup?.get('sheets')?.at(i)?.get('sheetTitleExists')?.get('value')?.value && this.formGroup?.get('sheets')?.at(i)?.get('updateSheetTitles')?.get('value')?.value) {
                <div class="d-flex align-items-center">
                  <ng-container>
                    <ng-container>
                      <mat-form-field matTooltip="You must give new title for existings ones. Or it will be selected by default." appearance="outline" class="w-100" >
                        <mat-label class="f-s-14 f-w-600 d-block">
                          {{column}}
                        </mat-label>
                        <input matInput type="text" [formControl]="formGroup?.get('sheets')?.at(i)?.get('sheetHeaders')?.at(k)?.get('key')" (change)="updateSheetHeader(i, k, $any($event.target).value)">
                      </mat-form-field>
                    </ng-container>
                    <ng-container>
                      <mat-form-field matTooltip="If you want to filter this data you can select the filters." appearance="outline" class="p-4">
                        <mat-label class="f-s-14 f-w-600 d-block">
                          <i-tabler name="filter"></i-tabler>
                        </mat-label>
                        <mat-select [formControl]="formGroup?.get('sheets')?.at(i)?.get('sheetHeaders')?.at(k)?.get('type')" (selectionChange)="updateSheetHeaderType(i, k, column, $any($event.value))">
                          <mat-option>None</mat-option>
                          @for (type of filterTypes; track type.toString()) {
                            <mat-option [value]="type">
                              {{ type }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <ng-container *ngIf="this.formGroup?.get('sheets')?.at(i)?.get('sheetHeaders')?.at(k)?.get('type')?.value?.includes('DATE')">
                        <mat-form-field matTooltip="Please choose the date type for accuracy. Or it will be setted as default." appearance="outline" class="w-100 p-4">
                          <mat-label>
                            Pick Date Type
                          </mat-label>
                          <mat-select (selectionChange)="selectDateTypes(i, k, $any($event.value))">
                            @for (dateFormatOption of dateFormatOptions; track dateFormatOption) {
                              <mat-option [value]="dateFormatOption">
                                {{ dateFormatOption }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              } @else if (this.formGroup?.get('sheets')?.at(i)?.get('sheetTitleExists')?.get('value')?.value) {
                <mat-label class="f-s-14 f-w-600 d-block m-b-10">
                  {{column}}
                </mat-label>
              } @else if (this.formGroup?.get('sheets')?.at(i)?.get('updateSheetTitles')?.get('value')?.value) {
                <div class="d-flex">
                  <mat-form-field appearance="outline" class="w-100 p-4" >
                    <input matInput type="text" [formControl]="formGroup?.get('sheets')?.at(i)?.get('sheetHeaders')?.at(k)?.get('key')" (change)="updateSheetHeader(i, k, $any($event.target).value)">
                  </mat-form-field>
                  <ng-container>
                    <mat-form-field matTooltip="If you want to filter this data you can select the filters." appearance="outline" class="p-4">
                      <mat-label class="f-s-14 f-w-600 d-block">
                        <i-tabler name="filter"></i-tabler>
                      </mat-label>
                      <mat-select [formControl]="formGroup?.get('sheets')?.at(i)?.get('sheetHeaders')?.at(k)?.get('type')" (selectionChange)="updateSheetHeaderType(i, k, column, $any($event.value))">
                        <mat-option>None</mat-option>
                        @for (type of filterTypes; track type.toString()) {
                          <mat-option [value]="type">
                            {{ type }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <ng-container *ngIf="this.formGroup?.get('sheets')?.at(i)?.get('sheetHeaders')?.at(k)?.get('type')?.value?.includes('DATE')">
                      <mat-form-field matTooltip="Please choose the date type for accuracy. Or it will be setted as default." appearance="outline" class="w-100 p-4">
                        <mat-label>
                          Pick Date Type
                        </mat-label>
                        <mat-select (selectionChange)="selectDateTypes(i, k, $any($event.value))">
                          @for (dateFormatOption of dateFormatOptions; track dateFormatOption) {
                            <mat-option [value]="dateFormatOption">
                              {{ dateFormatOption }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                  </ng-container>
                                  </div>
              } @else if (this.formGroup?.get('organizationSheetName')) {
                <div class="d-flex align-items-end">
                  <div style="flex-direction: column;" class="d-flex align-items-start justify-content-start p-r-5 ">
                    <div class="d-flex align-items-lg-center m-b-10 w-100">
                      <span class="bg-light-primary" *ngIf="selectedColumns[column]" style="display: inline-block;  border-radius: 50%;  width: 20px;  height: 20px;  text-align: center;  line-height: 20px;  margin-right: 5px;  font-size: 12px;">
                        {{ selectedColumns[column].index }}
                      </span>
                      <button mat-flat-button (click)="updateDivisionColumns(column)">
                        {{ column.length > 75 ? column.slice(0,75) + '...' : column }}
                      </button>
                    </div>
                    <mat-form-field matTooltip="Please enter a custom name for changing the default value of this line." appearance="outline" class="w-100">
                      <input matInput type="text" (change)="addOrUpdateColumnMappings(column, $any($event.target).value, undefined, undefined)" [placeholder]="'Translate ' + column">
                    </mat-form-field>
                  </div>
                  <ng-container>
                    <ng-container>
                      <mat-form-field matTooltip="If you want to filter this data you can select the filters." appearance="outline" class="p-r-5">
                        <mat-label class="f-s-14 f-w-600 d-block">
                          <i-tabler name="filter"></i-tabler>
                        </mat-label>
                        <mat-select (selectionChange)="addOrUpdateColumnMappings(column, undefined, $any($event.value), undefined)">
                          <mat-option>None</mat-option>
                          @for (type of filterTypes; track type.toString()) {
                            <mat-option [value]="type">
                              {{ type }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="this.formGroup.get('columnMappings')?.get(column)?.get('type')?.value?.includes('DATE')">
                    <mat-form-field matTooltip="Please choose the date type for accuracy. Or it will be setted as default." appearance="outline" class="w-100">
                      <mat-label>
                        Pick Date Type
                      </mat-label>
                      <mat-select (selectionChange)="addOrUpdateColumnMappings(column, undefined, 'DATE', $any($event.value))">
                        @for (dateFormatOption of dateFormatOptions; track dateFormatOption) {
                          <mat-option [value]="dateFormatOption">
                            {{ dateFormatOption }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  </ng-container>
                </div>
              }
            </th>
              <td mat-cell *matCellDef="let element" class="p-l-0 f-s-14">
                <div class="align-items-center">
                  {{ element[column] }}
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="sheet.columns"></tr>
            <tr mat-row *matRowDef="let row; columns: sheet.columns"></tr>
          </table>
          <div *ngIf="sheet.columns.length === 0" class="w-100 d-flex justify-content-center align-items-center p-30">
            Sheets first 5 row doesn't contain data.
          </div>
        </div>
        <div *ngIf="!this.formGroup?.get('organizationSheetName')" class="flex-1-auto">
          <app-user-decision-options
            *ngIf="uploadedFilesLength"
            [uploadedFilesLength]="uploadedFilesLength"
            [formGroup]="formGroup"
            [uploadedFiles]="this.formGroup?.get('uploadedFiles')?.getRawValue()"
            (userDecisionChange)="changeUserDecision($event[0], $event[1], $event[2])"
            [sheetIndexOfExcel]="i"
            [getOptionTypeIcon]="getOptionTypeIcon">
          </app-user-decision-options>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</app-code-view>
